module.exports = __webpack_public_path__ + "img/sample_03.61543f88.jpg";